import { Accordion, Badge, Code, Group, HoverCard, Stack, Text } from '@mantine/core';

import { UserAvatar } from '@/components';
import { config } from '@/config';
import { useAuth } from '@/contexts/AuthContext';
import classes from './TopNav.module.css';

export function ProfilePill() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const displayName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;

  return (
    <HoverCard width={320} shadow="md" position="bottom-end" openDelay={100} closeDelay={150}>
      <HoverCard.Target>
        <Group gap="xs" className={classes.profilePill}>
          <UserAvatar size="sm" />
          <Text size="sm" c="white" fw={500}>
            {displayName}
          </Text>
        </Group>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Stack gap="xs">
          <Text size="sm" fw={600}>
            {displayName}
          </Text>
          <Text size="xs" c="dimmed">
            {user.email}
          </Text>
          <Group gap="xs">
            {user.isAdministrator && (
              <Badge size="xs" color="yellow" variant="light">
                Admin
              </Badge>
            )}
            {user.isClient && (
              <Badge size="xs" color="blue" variant="light">
                Client
              </Badge>
            )}
            {user.isNetworkPartner && (
              <Badge size="xs" color="grape" variant="light">
                Network Partner
              </Badge>
            )}
          </Group>
          {config.isDevelopment && (
            <Accordion variant="filled" mt="xs" mx={`-${'sm'}`} chevronPosition="left">
              <Accordion.Item value="debug">
                <Accordion.Control>
                  <Text size="xs" fw={600}>
                    Debug
                  </Text>
                </Accordion.Control>
                <Accordion.Panel>
                  <Code block>{JSON.stringify(user, null, 2)}</Code>
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>
          )}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
